import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { deploy } from '../../deploy';

export interface VersionInfo {
  version: string;
  commit: string;
}

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  constructor(private http: HttpClient) { }

  getVersion(): Observable<VersionInfo> {
    return of({
      version: deploy.version,
      commit: 'N/A'
    });
  }
}
